import * as React from "react";
import { Col, Grid, Row } from "react-bootstrap";
import { Button, TextBox, Form, ValidationGroup, Validator, Toast } from 'devextreme-react'
import { Redirect } from "react-router-dom";
import { LoginAPI, DeviceTokenProvider } from "../../api";
import { LOGO_SVG } from "../../assets";
import { LoginUserError, LoginUserErrorType } from "../../api/src/endpoints/login";
import notify from 'devextreme/ui/notify';
import * as Fingerprint2 from 'fingerprintjs2'
import { createStyles, Theme, withStyles, WithStyles, CssBaseline } from "@material-ui/core";

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            backgroundColor: theme.palette.primary.dark,
            flexGrow: 1,
            padding: theme.spacing(3),
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            minHeight: '100vh',
            width: '100%'
        }
    })

class Login extends React.Component<WithStyles<typeof styles>, { redirectToReferrer: boolean }> {

    private validateAndSubmitFunc = this.validateAndSubmit.bind(this);

    private emailField: TextBox
    private passwordField: TextBox
    private validationGroup: ValidationGroup

    constructor(props) {
        super(props);
        this.state = {
            redirectToReferrer: false
        }
    }

    public componentDidMount() {
    }

    public render() {
        const { redirectToReferrer } = this.state
        if (redirectToReferrer === true) {
            return <Redirect to='/dashboard' />
        }
        return (
            <div className={this.props.classes.root}>
                <CssBaseline />
                <section id="login">
                    <Grid className="text-center">
                        <Row className="row1">
                            <Col className="col text-center">
                                <img alt="dashboard logo" src={LOGO_SVG} />
                                <div className="space" />
                            </Col>
                        </Row>
                        <Row className="row2">
                            <Col md={4} />
                            <Col md={4}>
                                <ValidationGroup ref={(ref) => this.validationGroup = ref!}>
                                    <div className="form-group">
                                        <TextBox ref={((ref) => this.emailField = ref!)} onEnterKey={this.validateAndSubmitFunc} elementAttr={{ class: 'form-control' }} mode="email" placeholder="E-mail" validationMessageMode="always">
                                            <Validator validationRules={[{ type: 'email', message: 'E-mail is invalid' }, { type: 'required', message: 'E-mail is required' }]} />
                                        </TextBox>
                                    </div>
                                    <br />
                                    <div className="form-group">
                                        <TextBox ref={((ref) => this.passwordField = ref!)} onEnterKey={this.validateAndSubmitFunc} elementAttr={{ class: 'form-control' }} mode="password" placeholder="password" validationMessageMode="always">
                                            <Validator validationRules={[{ type: 'required', message: 'Password is required' }]} />
                                        </TextBox>
                                    </div>
                                    <div className="space" />
                                    <Button onClick={this.validateAndSubmitFunc} elementAttr={{ class: 'button-logout' }} type='default' text="SIGN IN" />
                                </ValidationGroup>
                            </Col>
                            <Col md={4} />
                        </Row>
                    </Grid>
                </section>
            </div>
        )
    }

    private validateAndSubmit(params) {
        let result = this.validationGroup.instance.validate();
        if (result.isValid) {
            this.login()
        }
    }

    private login() {
        Fingerprint2.getV18({}, (result, components) => {
            const device = {
                app_version: require('../../../package.json').version,
                build_version: '1',
                device_uuid: result,
                device_data_os: 'web',
                app_type: 'admin',
                debug: process.env.REACT_APP_STAGE != 'production',
                token_provider: DeviceTokenProvider.Web,
                language: navigator.language
            }
            LoginAPI.login(this.emailField.instance.option('value')!, this.passwordField.instance.option('value')!, device).then((device) => {
                this.setState(() => ({
                    redirectToReferrer: true
                }))
            }).catch((error: LoginUserError) => {
                let text = 'An error occurred';
                switch (error.type) {
                    case LoginUserErrorType.invalidLogin:
                        text = (error.underlyingError && error.underlyingError.message) ? error.underlyingError.message : 'The password you entered was invalid';
                        break;
                    case LoginUserErrorType.userNotFound:
                        text = 'A user with this login could not be found';
                        break;
                    default:
                        break;
                }
                notify(text, 'error', 5000)
            })
        })
    }
}
export default withStyles(styles)(Login)


// WEBPACK FOOTER //
// ./src/pages/Login/Login.tsx